import { ThemeIcon, Tooltip, createStyles } from '@mantine/core';

import { IconQuestionMark } from '@tabler/icons-react';
import themeVariables from '@/styles/themeVariables';
import { useMediaQuery } from '@mantine/hooks';

const useQuestionMarkTooltipStyle = createStyles((theme) => ({
  actionIconContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
  },

  actionIcon: {
    backgroundColor: themeVariables.fontColors.light,
    color: theme.colors.gray[1],
    borderRadius: 30,
  },
}));

const QuestionMarkTooltip = ({ label, size = 21, position = '' }) => {
  const { classes } = useQuestionMarkTooltipStyle();
  const mobile = useMediaQuery(themeVariables.layout.mobile);

  return (
    <Tooltip
      multiline
      withArrow
      label={label}
      withinPortal
      m={3}
      arrowSize={6}
      width={'auto'}
      maw={'75vw'}
      color={themeVariables.colors.gray}
      events={{ hover: true, focus: true, touch: true }}
      transitionProps={{ duration: 150, transition: 'pop' }}
      transition={'pop'}
      position={position || mobile ? 'bottom' : 'right'}
    >
      <div className={classes.actionIconContainer}>
        <ThemeIcon size={size} className={classes.actionIcon}>
          <IconQuestionMark size={size - 4} stroke={2.5} />
        </ThemeIcon>
      </div>
    </Tooltip>
  );
};

export default QuestionMarkTooltip;
